import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: 'url("https://customer-assets.emergentagent.com/job_hageplanter-no/artifacts/2vl39vgf_image.png")',
        }}
      >
        {/* Gradient Overlay - Slightly stronger for readability */}
        <div className="absolute inset-0 bg-black/40 bg-gradient-to-r from-black/70 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative h-full container mx-auto px-4 flex flex-col justify-center">
        <div className="max-w-2xl text-white space-y-6 animate-fade-in-up">
          <div className="inline-block px-3 py-1 bg-accent/90 text-white text-sm font-semibold tracking-wide rounded-full mb-2">
            469 frøsorter – frakt til hele Norge
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold leading-tight drop-shadow-lg">
            Velkommen til <br/>
            <span className="text-secondary">Norsk Frøhandel</span>
          </h1>
          <p className="text-lg md:text-xl text-white/95 max-w-lg leading-relaxed drop-shadow-md">
            Din nettbutikk for blomsterfrø, grønnsaker og urter. Nøye utvalgt for norske klimaforhold – levert rett til døren.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <Link to="/category/blomster">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-full px-8 h-14 text-lg border-2 border-transparent w-full sm:w-auto">
                Utforsk frøene
              </Button>
            </Link>
            <Link to="/category/alle">
              <Button size="lg" variant="outline" className="bg-white/10 hover:bg-white/20 text-white border-white hover:border-white/80 rounded-full px-8 h-14 text-lg backdrop-blur-sm w-full sm:w-auto">
                Se alle produkter <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
